import Vue from 'vue';

export function updatePassword(data) {
  return Vue.axios({
    url: '/users/manage/update/password',
    method: 'post',
    data,
  });
}

export function getHkVendorConfig(params) {
  return Vue.axios({
    url: '/purchase/order/email/manage/getHkVendorConfig',
    params,
  });
}

export function updateNotificationEmail(data) {
  return Vue.axios({
    url: '/purchase/order/email/manage/updateNotificationEmail',
    method: 'post',
    data,
  });
}
